import { GridColumnTypes } from "@neutron/core/dist/types/models";
import { NeuGrid } from "@neutron/react";
import React from "react";

interface HasStyle { style?: React.CSSProperties }
interface HasChildren { children: React.ReactNode }
interface HasCssClass { className?: string }
/**
 * Thin wrapper around `<NeuContainer>`
 * @NeutronUpdate Replace the `<NeuContainer>` with a `<NeuGrid>` with no unit
 * This is the equivalent to the `<NeuContainer>` in Neutron 2 or the `<NeuGrid>` with no unit in Neutron 3.
 */

export function GridContainer(props: { fluid?: boolean | undefined } & HasChildren & HasCssClass & HasStyle) {
    return (
        <NeuGrid className={props.className} fluid={props.fluid} style={props.style}>
            {props.children}
        </NeuGrid>
    )
}

/**
 * Thin wrapper around `<NeuCol>`
 * @NeutronUpdate Will need to replace `<NeuCol>` with `<NeuGrid unit="column">`. `columns` will be deprecated
 */
export function GridColumn(props: { columns?: GridColumnTypes | boolean } & HasChildren & HasCssClass & HasStyle) {
    return (
        <NeuGrid unit="column" className={props.className} col={props.columns} style={props.style}>
            {props.children}
        </NeuGrid>
    )
}

/** 
 * Thin wrapper aound `<NeuRow>`
 * @NeutronUpdate Will need to replace `<NeuRow>` with `<NeuGrid unit="row">` */

export function GridRow(props: HasChildren & HasCssClass & HasStyle) {
    return (
        <NeuGrid unit="row" className={props.className} style={props.style}>
            {props.children}
        </NeuGrid>
    )
}